import { token } from 'odyssey';
import React from 'react';
import styled from 'styled-components';

type AccountHeaderProps = {
  children: React.ReactNode;
  isCompact?: boolean;
};

const Container = styled.div<{ isCompact?: boolean }>`
  padding-top: ${token('space-10')};
  padding-bottom: ${({ isCompact }) => (isCompact ? 'unset' : token('space-5'))};
`;

const StyledHeading = styled.h2`
  margin: 0;

  a {
    display: inline-flex;
    align-items: center;
    color: inherit;

    svg {
      fill: inherit;
      margin-right: ${token('space-8')};
    }
  }
`;

export function AccountHeader({ children, isCompact }: AccountHeaderProps) {
  return (
    <Container isCompact={isCompact}>
      <StyledHeading>{children}</StyledHeading>
    </Container>
  );
}
